import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { CheckDto, CheckItemDto, CheckSeatDto } from "src/app/shared/models/check-dto";
import { FocuslinkService } from "./focuslink.service";
import { OrderSocketService } from "./order-socket.service";
import { OOVenueService } from "./venue-service";

@Injectable({
	providedIn: "root",
})
export class OrderService {
	activeCheckKey: BehaviorSubject<string> = new BehaviorSubject<string>(undefined);
	activeOrder: BehaviorSubject<CheckDto> = new BehaviorSubject<CheckDto>(new CheckDto());
	activeSeat: BehaviorSubject<CheckSeatDto> = new BehaviorSubject<CheckSeatDto>(new CheckSeatDto());

	constructor(public venueService: OOVenueService, private focuslink: FocuslinkService, public orderSocketService: OrderSocketService) {}

	orderAddItemToSeat(item: CheckItemDto, seatKey: number, submitToPos: boolean) {
		const itemSeat = this.activeOrder.value.seats.find((seat) => seat.seatKey === seatKey);
		itemSeat.items.push(item);

		let proFormaCheck = this.activeOrder.value;
		if (submitToPos) {
			this.submitOrderToPos(this.activeOrder.value);
		} else {
			this.activeSeat.next(this.activeOrder.value.seats.find((seat) => this.activeSeat.value.seatKey === seat.seatKey));
		}
		return this.activeOrder.value;
	}

	setOrder(check: CheckDto) {
		if (!check.seats) {
			check.seats = [];
			check.seats[0].payments = [];
			check.seats[0].items = [];
		}
		this.activeOrder.next(check);
		this.activeCheckKey.next(check.checkKey);
		this.orderSocketService.connect(this.venueService.venueKey || check.venueKey, this.activeOrder.value.checkKey);
		if (!this.venueService.venueKey && check.venueKey) {
			this.venueService.venueKey = check.venueKey;
			this.venueService.subscriptionVenueKey.next(check.venueKey);
		}
		this.setOrderSeat(undefined, 0);

		this.orderSocketService.socketMessage.subscribe((msg) => {
			if (msg.message === "posCheckSave" && msg.payload?.checkKey === this.activeCheckKey.value) {
				this.activeOrder.next(new CheckDto(msg.payload));
			}
		});
	}

	async getCheck(venueKey: number, checkKey: string) {
		const resp = await this.focuslink.getCheck(venueKey, checkKey);
		this.activeOrder.next(new CheckDto(resp));
		console.log(this.activeOrder.value);
	}

	setOrderSeat(seatKey?: number, seatIndex?: number) {
		if (seatKey) {
			this.activeSeat.next(this.activeOrder.value.seats.find((seat) => seat.seatKey === seatKey));
			return this.activeSeat.value;
		}
		if (seatIndex) {
			this.activeSeat.next(this.activeOrder.value.seats[seatIndex]);
			return this.activeSeat.value;
		}
		this.activeSeat.next(this.activeOrder.value.seats[0]);
		return this.activeSeat.value;
	}

	async submitOrderToPos(order: CheckDto) {
		const resp = await this.focuslink.checkPut(order.venueKey, order);
		this.activeOrder.next(new CheckDto(resp));
		this.activeSeat.next(this.activeOrder.value.seats.find((seat) => this.activeSeat.value.seatKey === seat.seatKey));
		return new CheckDto(resp);
	}
}
